import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import Router from './app/routes';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import store from './app/redux/store/store';
import './app.css';
import { ToastContainer } from 'react-toastify';
import AdminHeader from './app/components/header/adminHeader';

require('./bootstrap');

const theme = createTheme({ typography: { allVariants: { fontFamily: 'Inter' } } });
if (document.getElementById('page-header') && (window.location.pathname.includes('/admin'))) {
    const root = ReactDOM.createRoot(document.getElementById('page-header'));
    root.render(
        <React.StrictMode>
            <ToastContainer />
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <BrowserRouter>
                        <AdminHeader
                            closeDrawer={()=>{}}
                            drawerOpen={false}
                            headerTitle={'PharmaforceIq Dashboard'}
                            openDrawer={true}
                        />
                    </BrowserRouter>
                </ThemeProvider>
            </Provider>
        </React.StrictMode>
    );
}

if (document.getElementById('react-app')) {
    const root = ReactDOM.createRoot(document.getElementById('react-app'));
    root.render(
        <React.StrictMode>
            <ToastContainer />
            <Provider store={store}>
                <ThemeProvider theme={theme}>
                    <BrowserRouter>
                        <Router />
                    </BrowserRouter>
                </ThemeProvider>
            </Provider>
        </React.StrictMode>
    );
}